module.exports = __webpack_public_path__ + "img/right1.8ff6eeea.png";